import React from "react";
import { useEffect } from "react";
import DatePicker from "react-date-picker";

import Navbarlogedin from "./Navbarlogedin";
import CancelRequest from "./popups/CancelRequest";
import SentRequest from "./cards/SentRequest";
import axios from "axios";
import "./SentRequests.css";
import { Helmet } from "react-helmet";

const changeLink = () => {
  const links = document.querySelectorAll(".nav-item a p");
  links.forEach((link) => {
    if (link.classList.contains("active")) {
      link.classList.remove("active");
    }
    if (link.innerHTML === "Sent Requests") {
      link.classList.add("active");
    }
  });
};

const SentRequests = (userDetails) => {
  const user = userDetails.user;
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    console.log(currentScrollPos);
    if (currentScrollPos >= 104) {
      document.querySelector("#head").style.position = "sticky";
      document.querySelector("#head").style.top = "-5px";
    } else {
      document.querySelector("#head").style.position = "unset";
      document.querySelector("#head").style.top = "0";
    }
    prevScrollpos = currentScrollPos;
  };
  const [sentcards, setSentards] = React.useState();
  useEffect(() => {
    async function fetchData() {
      const req = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/get`);
      setSentards(req.data);
    }
    fetchData();
  }, []);
  useEffect(() => {
    changeLink();
  }, []);
  const [date, setDate] = React.useState(null);
  return (
    <>
      <Helmet>
        <title>Interwiu | Requests</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <CancelRequest />
      <div className="sent-request interviews">
        <div className="interviews-container">
          <div className="flex justify-center items-center my-4" id="head">
            <h2 className="interview-head text-2xl font-medium">
              Sent Requests 78
            </h2>
          </div>
          <div className="interviews-cont">
            <div className="flex justify-between mx-8">
              <div>
                Showing the results for{" "}
                {date ? date.toDateString() : "all days"}
              </div>
              <div className="flex gap-2">
                <label htmlFor="date">Filter by Date: </label>
                <DatePicker
                  onChange={(newValue) => {
                    setDate(newValue);
                  }}
                  value={date}
                />
              </div>
            </div>
            <div className="interviews-list">
              <SentRequest
                user="{user}"
                name="John Doe"
                desg="ML Engineer, Walmart, USA"
                price="299"
                profile="Data Science"
                slot="12:00 PM - 12:30 PM"
                status="pending"
                id="#y8as7f"
                logo={require("../../images/amazon.png")}
              />
              <SentRequest
                user="{user}"
                name="John Doe"
                desg="ML Engineer, Walmart, USA"
                price="299"
                profile="Data Science"
                slot="12:00 PM - 12:30 PM"
                status="pending"
                id="#y8as7f"
                logo={require("../../images/amazon.png")}
              />
              {sentcards?.map((result) => (
                <>
                  <SentRequest
                    user={user}
                    name={result.toname}
                    desg={result.desg}
                    price={result.price}
                    profile={result.profile}
                    slot={result.slot}
                    status={result.status}
                    id={result._id}
                    logo={require("../../images/amazon.png")}
                  />
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SentRequests;
